import type { CSSProperties, ReactElement } from 'react';
import type { FieldError } from 'react-hook-form';

export interface SelectOptionType<Value> {
  label: string;
  labelIcon?: ReactElement;
  subLabel?: string;
  value: Value;
  disabled?: boolean;
}

interface CreateableProps<Value> {
  onCreate: (value: string) => Promise<Value>;
  itemType: string;
}

type SearchableProps<Value> =
  | {
      isSearchable: true;
      /** Prevent default search for filtering `options` based on input
       */
      preventFilterSearch?: boolean;
      onInputChange?: (input: string) => void;
      createProps?: CreateableProps<Value>;
    }
  | {
      isSearchable?: false;
      preventFilterSearch?: never;
      onInputChange?: never;
      createProps?: never;
    };

export type CommonSelectProps<Value> = SearchableProps<Value> & {
  className?: string;
  label: string;
  labelClassName?: string;
  labelIsHidden?: boolean;
  subLabel?: string;
  flag?: string;
  placeholder?: string;
  options: Array<SelectOptionType<Value>>;
  isValueEqual?: (v1: Value, v2: Value) => boolean;
  loading?: boolean;
  renderOption?: (value: Value, isSelected?: boolean) => ReactElement;
  error?: FieldError;
  required?: boolean;
  customErrorMessage?: string;
  disabled?: boolean;
};

export const DEFAULT_NO_OPTIONS_LABEL = 'No options';

export const createableLabel = (input: string, itemType: string): string => {
  return `Create ${itemType} "${input}"`;
};

export const getSelectDropdownStyles = (rect?: DOMRect): CSSProperties => ({
  top: (rect?.bottom ?? 0) + window.scrollY,
  left: (rect?.x ?? 0) + window.scrollX,
  width: rect?.width,
  // z-index must be greater than 30 to layer on top of modal overlay
  zIndex: 50,
});
